module.exports = __webpack_public_path__ + "static/MedalRanking3.d59c13f8.png";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/assets/MedalRanking3.png
// module id = 2949
// module chunks = 0